import React, { useEffect, useState } from 'react';
import {
  Wrench,
  Clock3,
  CheckCircle2,
  AlertTriangle,
  Car,
  Users,
  Plus,
  Activity,
  ClipboardList
} from 'lucide-react';

import './Home.css';

const Home = () => {

  const first_name = localStorage.getItem('fpfirstName');
  const last_name = localStorage.getItem('fplastName');

  const [loading, setLoading] = useState(true);

  const [dashboardData, setDashboardData] = useState({
    stats: {},
    recentOrders: [],
    alerts: [],
    activities: []
  });

  useEffect(() => {

    const fetchDashboard = async () => {

      setLoading(true);

      // MOCK API DELAY
      setTimeout(() => {

        setDashboardData({

          stats: {
            openOrders: 18,
            progressOrders: 7,
            completedOrders: 124,
            delayedOrders: 5,
            totalClients: 312,
            totalVehicles: 198
          },

          recentOrders: [
            {
              id: 1024,
              client: 'João Silva',
              vehicle: 'Gol 1.6',
              status: 'Em andamento',
              date: '08/05/2026'
            },
            {
              id: 1025,
              client: 'Carlos Oliveira',
              vehicle: 'Onix LT',
              status: 'Finalizada',
              date: '08/05/2026'
            },
            {
              id: 1026,
              client: 'Fernanda Costa',
              vehicle: 'HB20',
              status: 'Atrasada',
              date: '07/05/2026'
            }
          ],

          alerts: [
            '3 ordens estão atrasadas',
            '2 veículos aguardando peças',
            '1 cliente aguardando retorno'
          ],

          activities: [
            'Ordem #1025 foi finalizada',
            'Novo cliente cadastrado',
            'Veículo Fiat Uno registrado',
            'Backup realizado com sucesso'
          ]

        });

        setLoading(false);

      }, 1800);

    };

    fetchDashboard();

  }, []);

  const getStatusClass = (status) => {

    switch (status) {
      case 'Finalizada':
        return 'success';

      case 'Em andamento':
        return 'warning';

      case 'Atrasada':
        return 'danger';

      default:
        return '';
    }
  };

  if (loading) {
    return (
      <div className="home-loading">
        <div className="home-spinner"></div>
        <span>Carregando dashboard...</span>
      </div>
    );
  }

  return (
    <div className="home-container">

      {/* HEADER */}
      <div className="home-header">

        <div>
          <h1>
            Olá, {first_name} {last_name} 👋
          </h1>

          <p>
            Aqui está o resumo do sistema hoje.
          </p>
        </div>

        <div className="home-date">
          {new Date().toLocaleDateString('pt-BR')}
        </div>

      </div>

      {/* CARDS */}
      <div className="home-cards">

        <div className="home-card">
          <div className="home-card-icon green">
            <ClipboardList size={22} />
          </div>

          <div>
            <span>Ordens Abertas</span>
            <strong>{dashboardData.stats.openOrders}</strong>
          </div>
        </div>

        <div className="home-card">
          <div className="home-card-icon yellow">
            <Clock3 size={22} />
          </div>

          <div>
            <span>Em Andamento</span>
            <strong>{dashboardData.stats.progressOrders}</strong>
          </div>
        </div>

        <div className="home-card">
          <div className="home-card-icon blue">
            <CheckCircle2 size={22} />
          </div>

          <div>
            <span>Finalizadas</span>
            <strong>{dashboardData.stats.completedOrders}</strong>
          </div>
        </div>

        <div className="home-card">
          <div className="home-card-icon red">
            <AlertTriangle size={22} />
          </div>

          <div>
            <span>Pendências</span>
            <strong>{dashboardData.stats.delayedOrders}</strong>
          </div>
        </div>

      </div>

      {/* GRID */}
      <div className="home-grid">

        {/* ORDERS */}
        <div className="home-panel">

          <div className="home-panel-header">
            <h2>Últimas Ordens</h2>
          </div>

          <table className="home-table">

            <thead>
              <tr>
                <th>#</th>
                <th>Cliente</th>
                <th>Veículo</th>
                <th>Status</th>
                <th>Data</th>
              </tr>
            </thead>

            <tbody>

              {dashboardData.recentOrders.map((order) => (

                <tr key={order.id}>

                  <td>#{order.id}</td>

                  <td>{order.client}</td>

                  <td>{order.vehicle}</td>

                  <td>
                    <span className={`status-badge ${getStatusClass(order.status)}`}>
                      {order.status}
                    </span>
                  </td>

                  <td>{order.date}</td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

        {/* SIDE */}
        <div className="home-side">

          {/* QUICK ACTIONS */}
          <div className="home-panel">

            <div className="home-panel-header">
              <h2>Ações Rápidas</h2>
            </div>

            <div className="quick-actions">

              <button>
                <Plus size={18} />
                Nova Ordem
              </button>

              <button>
                <Users size={18} />
                Novo Cliente
              </button>

              <button>
                <Car size={18} />
                Novo Veículo
              </button>

            </div>

          </div>

          {/* ALERTS */}
          <div className="home-panel">

            <div className="home-panel-header">
              <h2>Alertas</h2>
            </div>

            <div className="alerts-list">

              {dashboardData.alerts.map((alert, index) => (
                <div className="alert-item" key={index}>
                  <AlertTriangle size={16} />
                  {alert}
                </div>
              ))}

            </div>

          </div>

          {/* TIMELINE */}
          <div className="home-panel">

            <div className="home-panel-header">
              <h2>Atividades</h2>
            </div>

            <div className="timeline-list">

              {dashboardData.activities.map((activity, index) => (
                <div className="timeline-item" key={index}>
                  <Activity size={15} />
                  {activity}
                </div>
              ))}

            </div>

          </div>

        </div>

      </div>

    </div>
  );
};

export default Home;